/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TOTPRegisterAttestationData
 */
export interface TOTPRegisterAttestationData {
    /**
     * 
     * @type {string}
     * @memberof TOTPRegisterAttestationData
     */
    otp?: string;
}

/**
 * Check if a given object implements the TOTPRegisterAttestationData interface.
 */
export function instanceOfTOTPRegisterAttestationData(value: object): value is TOTPRegisterAttestationData {
    return true;
}

export function TOTPRegisterAttestationDataFromJSON(json: any): TOTPRegisterAttestationData {
    return TOTPRegisterAttestationDataFromJSONTyped(json, false);
}

export function TOTPRegisterAttestationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TOTPRegisterAttestationData {
    if (json == null) {
        return json;
    }
    return {
        
        'otp': json['otp'] == null ? undefined : json['otp'],
    };
}

export function TOTPRegisterAttestationDataToJSON(json: any): TOTPRegisterAttestationData {
    return TOTPRegisterAttestationDataToJSONTyped(json, false);
}

export function TOTPRegisterAttestationDataToJSONTyped(value?: TOTPRegisterAttestationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'otp': value['otp'],
    };
}

